var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav d-flex flex-column ml-3"},_vm._l((_vm.filterCategory),function(item){return _c('li',{key:item,staticClass:"nav-item"},[_c('router-link',{class:_vm.color(item),attrs:{"to":{
        path: ("/shopping/" + _vm.category),
        query: ( _obj = {
          page: 1
        }, _obj[_vm.category] = item, _obj )
      }}},[_vm._v(_vm._s(item))])],1)
var _obj;}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21353d8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBarCollapse.vue
// module id = null
// module chunks = 